// material-ui
import { alpha } from '@mui/material/styles';

// ==============================|| DEFAULT THEME - CUSTOM SHADOWS - MODERN ||============================== //

export default function CustomShadows(theme) {
  return {
    button: `0 2px 4px ${alpha(theme.palette.grey[900], 0.1)}`,
    text: `0 -1px 0 ${alpha(theme.palette.grey[900], 0.12)}`,
    z1: `0 1px 2px 0 ${alpha(theme.palette.grey[900], 0.05)}`,
    z2: `0 4px 6px -1px ${alpha(theme.palette.grey[900], 0.1)}, 0 2px 4px -1px ${alpha(theme.palette.grey[900], 0.06)}`,
    z3: `0 10px 15px -3px ${alpha(theme.palette.grey[900], 0.1)}, 0 4px 6px -2px ${alpha(theme.palette.grey[900], 0.05)}`,
    z4: `0 20px 25px -5px ${alpha(theme.palette.grey[900], 0.1)}, 0 10px 10px -5px ${alpha(theme.palette.grey[900], 0.04)}`,
    z8: `0 20px 25px -5px ${alpha(theme.palette.grey[900], 0.15)}`,
    z12: `0 25px 50px -12px ${alpha(theme.palette.grey[900], 0.15)}`,
    z16: `0 25px 50px -12px ${alpha(theme.palette.grey[900], 0.2)}`,
    z24: `0 25px 50px -12px ${alpha(theme.palette.grey[900], 0.25)}`
    // only available in paid version
  };
}
